var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMinimartBulkUpload = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 12 L6.5 5.5 H27.5 L30 12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 12 V28 a1.5 1.5 0 0 0 1.5 1.5 H12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 12 V17"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 12 a3.2 3.2 0 0 0 6.5 0 a3.2 3.2 0 0 0 6.5 0 a3.2 3.2 0 0 0 6.5 0 a3.2 3.2 0 0 0 6.5 0"
}), /*#__PURE__*/React.createElement("line", {
  x1: 23,
  y1: 30.5,
  x2: 23,
  y2: 21
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 25 L23 21 L27 25"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMinimartBulkUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_minimart_bulk_upload.0cdc468086fed759d819d90bba20a9cb.svg";